(function () {
    'use strict';
    var controllerId = 'contrattoAttachEdit';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', '$filter', 'datacontext', 'common', 'contrattoAttach', contrattoAttachEditFn]);

    function contrattoAttachEditFn($scope, $uibModalInstance, $filter, datacontext, common, contrattoAttach) {
        $scope.contrattoAttach = contrattoAttach;
        $scope.fileName = contrattoAttach.FileName;
        $scope.data = $filter('date')($scope.contrattoAttach.Data, 'dd/MM/yyyy');

        $scope.ok = function (isValid) {
            if (isValid) {
                var result = editItem($scope.contrattoAttach);
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function editItem(item) {
            return datacontext.contrattoAttach_update(item).then(function (data) {
                if (!data || data.Id == null || data.Id == 0) return null;
                return data;
            });
        }
    }
})();